module.exports = __webpack_public_path__ + "static/media/homepage_bw.f55d37ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/homepage_bw.jpg
// module id = 297
// module chunks = 0